import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CurrencyPipe } from '../../shared/pipes/currency.pipe';
import { CardItemModel, CategoryModel } from '../finance.model';
import { parseInstallment } from './card-statement-parser';

export interface CardItemDialogData {
  item: Partial<CardItemModel>,
  categories: CategoryModel[]
}

@Component({
  selector: 'finance-card-item-dialog',
  standalone: false,
  template: `
    <form #form="ngForm" (ngSubmit)="save(form.value)">
      <h2 mat-dialog-title>{{ item.id ? 'Modify' : 'Create' }} Statement Item</h2>
      <mat-dialog-content>
        <mat-form-field style="width: 100%;">
          <mat-label>Description</mat-label>
          <input matInput [(ngModel)]="item.description" name="description" placeholder="MERCADOLIVRE*2PARC02/04" required>
        </mat-form-field>
        <mat-divider></mat-divider>
        <mat-form-field>
          <mat-label>Category</mat-label>
          <mat-select [(ngModel)]="item.category" name="category">
            <mat-option value="">—</mat-option>
            <mat-option *ngFor="let c of data.categories" [value]="c.name">{{ c.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Value</mat-label>
          <input matInput type="text" currency [ngModel]="item.value | number:'1.2-2' | currency" name="value" placeholder="0,00" required>
        </mat-form-field>
        <mat-divider></mat-divider>
        <mat-form-field>
          <mat-label>Installment</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="item.installment" name="installment" placeholder="2">
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Of</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="item.installments" name="installments" placeholder="4">
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button type="submit" [disabled]="form.invalid">Save</button>
        <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
      </mat-dialog-actions>
    </form>
  `
})
export class CardItemDialogComponent {
  item: Partial<CardItemModel>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CardItemDialogData,
    private dialogRef: MatDialogRef<CardItemDialogComponent>,
    private currencyPipe: CurrencyPipe
  ) {
    this.item = { description: '', category: '', value: 0, installment: null, installments: null, ...data.item };
  }

  save(values: any): void {
    const description = (this.item.description ?? '').trim();
    // "PARC02/04" in the description fills the installment when it was left empty
    const parsed = parseInstallment(description);

    this.dialogRef.close({
      ...this.item,
      description,
      category: this.item.category ?? '',
      value: parseFloat(this.currencyPipe.transform(values['value'], false)),
      installment: this.item.installment || parsed?.installment || null,
      installments: this.item.installments || parsed?.installments || null
    });
  }
}
